export const appendParamsToUrl = (url: string, params: Record<string, string | undefined>) => {
  const [baseUrl, queryString] = url.split("?"); // Split the URL into base and query string
  const searchParams = new URLSearchParams(queryString); // Parse the existing query string

  // Append new parameters
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.set(key, value); // Add or update the parameter
    }
  });

  // Reconstruct the URL with the updated query string
  return searchParams.toString() ? `${baseUrl}?${searchParams.toString()}` : baseUrl;
};
